import { Theme } from "theme-ui";

const loadFonts = (allFonts: string[]): void => {
  if (typeof window === "undefined") {
    return;
  }

  const webfont = (window as any)?.WebFont;
  if (webfont && "load" in webfont && allFonts.length > 0) {
    allFonts.forEach((font) => {
      try {
        webfont.load({
          google: {
            families: [font],
          },
        });
      } catch (e) {
        // Suppress, font is probably no google font
        // eslint-disable-next-line no-console
        console.log(`Unable to load font: ${font}`, e);
      }
    });
  }
};

export const fontLoader = (theme: Theme | any): void => {
  const fontFamilies: string[] = Object.keys(theme.fonts ?? {})
    .filter((key) => key !== "icons")
    .map((key) => theme?.fonts[key])
    .filter((e) => e);

  let allFonts: string[] = [];
  for (const fontFamily of fontFamilies) {
    allFonts = allFonts.concat(
      fontFamily
        .split(",")
        .map((f) =>
          f.trim().replace('\\"', "").replace('"', "").replace('"', "")
        )
    );
  }
  if (!allFonts || allFonts.length <= 0) return;

  if (typeof document !== "undefined" && document.fonts) {
    document.fonts.ready.then(() => {
      loadFonts(allFonts);
    });
  } else {
    loadFonts(allFonts);
  }
};
